import { UI_STRINGS } from '../../functions/language/uistrings';

export type ClientFeatureFlag = {
  id: string;
  name: ClientFeatureFlagName;
  status: 'IN_DEVELOPMENT' | 'ALPHA' | 'BETA' | 'GA';
};

export enum ClientFeatureFlagName {
  CityProgressOverviewContent = 'cityProgressOverviewContent',
  Panorama = 'panorama',
  NewDashboardNavigationV3 = 'dashboardNavigation',
  DashboardHideEnergyModel = 'dashboardHideEnergyModel',
  DevZone = 'devZone',
  ExportEchartsAsPng = 'exportEchartsAsPng',
  ExportPaperAsPNG = 'exportPaperAsPNG',
  DisableEditingEmissionReductionAndEnergySavingInfo = 'disableEditingEmissionReductionAndEnergySavingInfo',
  ActionEditorImpactTab = 'actionEditorImpactTab',
  ActionEditorKPITab = 'actionEditorKPITab',
  ChartDataPrintOut = 'chartDataPrintOut',
  DashboardV3 = 'dashboardV3',
  DashboardV4 = 'dashboardEmissionReductionScenario',
  Brazil = 'brazil',
  GHGCorporate = 'ghgCorporate',
  MultipleScenarios = 'multipleScenarios',
  OutcomeAssessmentForInterventions = 'outcomeAssessmentForInterventions',
  AnalyticsPortalAuditLogLinks = 'analyticsPortalAuditLogLinks',
  InterventionsExportImport = 'interventionsExportImport',
  PanoramaGA = 'panoramaGA',
  ActivityOutcome = 'activityOutcome',
  KeanInventoryAndDashboard = 'keanInventoryAndDashboard',
}

export const FeatureFlags = [
  {
    name: ClientFeatureFlagName.CityProgressOverviewContent,
    title: UI_STRINGS.FEATURE_FLAGS.CITY_PROGRESS_OVERVIEW_CONTENT_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.CITY_PROGRESS_OVERVIEW_CONTENT_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.Panorama,
    title: UI_STRINGS.FEATURE_FLAGS.PANORAMA_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.PANORAMA_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.NewDashboardNavigationV3,
    title: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_NAVIGATION_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_NAVIGATION_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.DashboardV4,
    title: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_EMISSION_REDUCTION_SCENARIO_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_EMISSION_REDUCTION_SCENARIO_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.DashboardHideEnergyModel,
    title: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_HIDE_ENERGY_MODEL_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_HIDE_ENERGY_MODEL_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ExportEchartsAsPng,
    title: UI_STRINGS.FEATURE_FLAGS.EXPORT_ECHARTS_AS_PNG_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.EXPORT_ECHARTS_AS_PNG_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ExportPaperAsPNG,
    title: UI_STRINGS.FEATURE_FLAGS.EXPORT_PAPER_AS_PNG_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.EXPORT_PAPER_AS_PNG_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.DisableEditingEmissionReductionAndEnergySavingInfo,
    title: UI_STRINGS.FEATURE_FLAGS.DISABLE_EDITING_EMISSION_REDUCTION_AND_ENERGY_SAVING_INFO_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.DISABLE_EDITING_EMISSION_REDUCTION_AND_ENERGY_SAVING_INFO_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ActionEditorImpactTab,
    title: UI_STRINGS.FEATURE_FLAGS.ACTION_EDITOR_IMPACT_TAB_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.ACTION_EDITOR_IMPACT_TAB_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ActionEditorKPITab,
    title: UI_STRINGS.FEATURE_FLAGS.ACTION_EDITOR_KPI_TAB_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.ACTION_EDITOR_KPI_TAB_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ChartDataPrintOut,
    title: UI_STRINGS.FEATURE_FLAGS.CHART_DATA_PRINT_OUT_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.CHART_DATA_PRINT_OUT_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.Brazil,
    title: UI_STRINGS.FEATURE_FLAGS.BRAZIL_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.BRAZIL_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.DashboardV3,
    title: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_V3_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.DASHBOARD_V3_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.GHGCorporate,
    title: UI_STRINGS.FEATURE_FLAGS.GHG_CORPORATE_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.GHG_CORPORATE_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.OutcomeAssessmentForInterventions,
    title: UI_STRINGS.FEATURE_FLAGS.OUTCOME_ASSESSMENT_FOR_INTERVENTIONS_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.OUTCOME_ASSESSMENT_FOR_INTERVENTIONS_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.AnalyticsPortalAuditLogLinks,
    title: UI_STRINGS.FEATURE_FLAGS.ANALYTICS_PORTAL_AUDIT_LOG_LINKS_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.ANALYTICS_PORTAL_AUDIT_LOG_LINKS_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.InterventionsExportImport,
    title: UI_STRINGS.FEATURE_FLAGS.INTERVENTIONS_EXPORT_IMPORT_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.INTERVENTIONS_EXPORT_IMPORT_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.PanoramaGA,
    title: UI_STRINGS.FEATURE_FLAGS.PANORAMA_GA_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.PANORAMA_GA_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.ActivityOutcome,
    title: UI_STRINGS.FEATURE_FLAGS.ACTIVITY_OUTCOME_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.ACTIVITY_OUTCOME_DESCRIPTION,
  },
  {
    name: ClientFeatureFlagName.KeanInventoryAndDashboard,
    title: UI_STRINGS.FEATURE_FLAGS.KEAN_INVENTORY_AND_DASHBOARD_TITLE,
    description: UI_STRINGS.FEATURE_FLAGS.KEAN_INVENTORY_AND_DASHBOARD_DESCRIPTION,
  },
];
